module.exports = {
  pleaseWait: 'Пожалуйста, подождите',
  loading: 'Загрузка',
  Billing: 'Покупки',
  billingTips: 'Ваши недавние покупки',
  ID: 'ID',
  FAQ: 'Часто задаваемые вопросы',
  TC: 'Положения и условия',
  Copyright: '© 2026 Все права защищены.',
  GenerateImage: 'Создать изображение',
  generateTips1: 'Генератор изображений на базе AI воплощает воображение в реальность, создавая потрясающее искусство, иллюстрации и фотографии за считанные секунды. Раскройте свою креативность и выражайте себя новыми способами с помощью AI. Исследуйте бесконечные возможности — от создания уникальных маркетинговых материалов до красивых произведений искусства, все это с непревзойденной легкостью и эффективностью.',
  generateTips2: 'Введите несколько слов ниже, и наблюдайте, как SnapAI превращает текст в невероятное искусство.',
  Prompt: 'Подсказка',
  PromptTips1: 'Подскажите AI, что требуется создать.',
  PromptTips2: 'Советы: опишите настроение и освещение. См. страницу с советами для получения дополнительных рекомендаций.',
  PromptTips3: 'Примечание: AI иногда может не следовать инструкциям и AI не умеет считать.',
  Generate: 'Создать',
  ChancesLeft: 'Попыток осталось',
  BuyChances: 'Приобрести больше попыток',
  generateImageTips1: 'Введите, что вы хотите создать',
  generatePromptsTips1: 'Введите чего вы не хотите на изображении',
  indexTips1: 'Ежедневные бесплатные попытки <br /> Доступны!',
  indexTips2: 'Выберите функцию',
  ImageRestorer: 'Восстановитель фотографий',
  Continue: 'Продолжить',
  language0: 'Язык',
  language: 'Выберите язык',
  languageTips: 'Выберите язык здесь',
  Submit: 'Подтвердить',
  change: 'Сохранить',
  lang_1: 'English',
  lang_3: "O'zbekcha",
  lang_2: 'Русский',
  Login: 'Войти',
  Logout: 'Выйти',
  getCode: 'Отправить повторно',
  loginTips: 'Введите номер телефона',
  profile: 'Профиль',
  phoneNumber: 'Номер телефона',
  SubscribedSince: 'Подписка от',
  RemainingChances: 'Оставшиеся попытки',
  cgtips2: 'Всего 1500 сум/день,<br />нажмите OK, чтобы подписаться.',
  OK: 'OK',
  PictureRestorer: 'Восстановитель фотографий',
  PictureTips1: 'Восстанавливайте, улучшайте и исправляйте изображения с помощью AI. SnapAI основывается на последних исследованиях, чтобы автоматически удалять царапины, улучшать цвета и лица, превращая поврежденные фотографии в драгоценные воспоминания. Наша бесплатная услуга восстанавливает как цветные, так и черно-белые фотографии.',
  Upload: 'Загрузить',
  PictureTips2: 'Царапины на фото?',
  Restore: 'Восстановить',
  uploadTips: 'Пожалуйста загрузите фото',
  PurchaseChances: 'Приобрести попытки',
  History: 'История',
  purchaseTips1: 'Осталось попыток',
  purchaseTips2: 'Одноразовая покупка',
  Daily: 'Ежедневная подписка',
  Purchase: 'Приобрести',
  DailyKyats: '1500 сум',
  Subscribe: 'Подписаться',
  logout: 'Выйти',
  petTitle1: 'AI аниме питомцы',
  petTitle2: 'Выберите стиль',
  petContent1: 'Преобразуйте фото вашего любимого питомца в причудливый шедевр в аниме-стиле. Идеально подходит для любителей животных и энтузиастов аниме, SnapAI предлагает веселый и персонализированный способ преобразить ваших пушистых друзей.',
  sexTitle1: 'AI аниме селфи',
  sexTitle2: 'Выберите пол',
  sexContent1: 'Оживляет ваше воображение, создавая фотографии в аниме-стиле на основе текстовых подсказок. Независимо от того, являетесь ли вы фанатом аниме, рассказчиком или дизайнером, AI аниме фото позволяет вам легко создавать яркие, высококачественные визуалы в аниме-стиле, сочетая AI с вашим уникальным видением.',
  sexContent2: 'Выберите стиль ниже и наблюдайте, как SnapAI превращает текст в удивительное искусство.',
  Female: 'Женский',
  Male: 'Мужской',
  Style1: 'Стиль 1',
  Style2: 'Стиль 2',
  Style3: 'Стиль 3',
  Comic: 'Комикс',
  Disney: 'Дисней',
  Ghibli: 'Гибли',
  Animalanime: 'Аниме селфи',
  HumanAnime: 'Аниме персона',
  Guidance: 'Руководство',
  PetAnime: 'Аниме питомцы',
  landTips1: 'Создавайте потрясающие фотографии и',
  landTips2: 'ВЫИГРЫВАЙТЕ БОЛЬШИЕ ПРИЗЫ!',
  landTips3: 'Оживите свое воображение с SnapAI! От великолепной генерации фотографий до художественных шедевров — SnapAI дает вам возможность создавать визуальные произведения искусства, как никогда ранее. Погрузитесь в мир безграничных возможностей.',
  show401tip: 'Недостаточный баланс',
  show400dailytip: 'Превышение времени, пожалуйста отправьте "AID" на короткий номер 88800, чтобы выиграть призы.',
  register: 'Регистрация',
  invitation: 'Пригласить друга',
  invitationTips: 'Скопируйте и отправьте приглашение, используя ссылку ниже',
  InviteNow: 'Пригласить',
  copySuccess: 'Скопировано успешно!',
  CopySucceeded: 'Скопировано успешно!',
  process: 'В процессе',
  downTips1: 'Пожалуйста, скопируйте ссылку в браузер, чтобы скачать фото.',
  copyLink: 'Скопировать',
  free: 'Бесплатно',
  aiAnimeTitle: 'AI аниме в паре',
  aiAnimeCt1: 'Преобразуйте свои оригинальные фотографии в стиль аниме, придавая вашим романтическим моментам ещё больше веселья. Независимо от того, являетесь ли вы поклонником аниме или дизайнером, AI аниме в паре позволяет легко создавать высококачественные аниме-изображения, гармонично сочетая передовые технологии AI с вашими воспоминаниями.',
  aiAnimeCt2: 'Выберите стиль ниже и загрузите свою оригинальную фотографию и наблюдайте, как SnapAI преображает ваши милые воспоминания в потрясающие произведения искусства.',
  comingsoonT: 'Скоро',
  SubscribePackage: 'Подписаться',
  landfont1: 'Преобразовывайте фотографии в потрясающее аниме искусство.',
  landfont2: 'Преобразуйте ваши фотографии в паре в красивые аниме персонажи.',
  landfont3: 'Напишите запрос для создания красивых изображений.',
  landfont4: 'Преобразуйте ваших питомцев в милых аниме персонажей с помощью магии AI.',
  landfont5: 'Восстановите свои воспоминания с помощью восстановления фотографий на базе AI.',
  SmartCutout: 'Умное вырезание',
  letgo: 'Выбрать!',
  IpIMage: 'ID фото',
  IpIMageTip: 'Нужна фотография для ID или удостоверения личности? Мы вам поможем!',
  IpIMage_content: 'Исходное изображение, загруженное для ID фото, должно четко показывать лицо без каких-либо препятствий (волосы, очки и т.д.), а плечи должны быть на одном уровне. В противном случае генерация не получится.',
  snapbot: 'SnapBot',
  snapbot_hi: 'Привет, Я SnapBot.',
  help_today: 'Как я могу вам помочь?',
  think_ip: '🤖 Думаю...',
  Coloring_old_photos: 'Перекраска изображений',
  Coloring_old_photos_tips: 'Восстановите цвет на ваших старых фотографиях\n' +
    'и верните свои воспоминания к жизни. Наш инструмент на базе AI\n' +
    'автоматически анализирует изображения и добавляет естественные цветовые оттенки,\n' +
    'сохраняя очарование оригинала\n' +
    'и улучшая визуальную привлекательность.\n',
  Coloring_old_photos_tips2: 'Восстановите свои старые фотографии с помощью исправления цвета на основе AI.',
  BgFusion: 'Смена фона',
  BgFusion_tips2: 'Настройте ваше фото, выбрав желаемый фон',
  BgFusion_tips: 'Настройте ваше фото, выбрав желаемый фон.\n' +
    'AI заменяет оригинальный фон\n' +
    'и естественно интегрирует ваше изображение на новый фон',
  Upload_bg: 'Загрузить фон',
  Upload_pt: 'Загрузить селфи',
  Recolor: 'Перекрасить',
  snapbotTips1: 'Результаты быстрого поиска',
  snapbotTips2: 'Обработка естественного языка',
  snapbotTips3: 'Анализ больших данных',
  snapbotTips4: 'Алгоритмы на базе AI',
  snapbotInput1: 'Нажмите здесь, чтобы начать общение с SnapBot',
  white: 'Белый',
  blue: 'Голубой',
  '1 inch': '35×45 мм',
  '2 inches': '50×50 мм',
  landTips11: 'Создавайте потрясающие фотографии и',
  ChangeHairstyle: 'Магия смены прически',
  ChangeHairstyle_short: 'Попробуйте прически о которых вы всегда мечтали',
  ChangeHairstyle_content_1: 'SnapAI предлагает функцию изменения причесок, позволяя пользователям примерять разные стрижки в реальном времени или на загруженных фотографиях. Эта функция использует технологии AI для анализа черт лица пользователя и предлагает прически, которые подходят их форме лица, предпочтениям и стилю. Пользователи могут экспериментировать с различными образами — от легких изменений до смелых и драматических трансформаций, получая виртуальный предварительный просмотр перед тем, как решиться на реальные изменения.',
  ChangeHairstyle_content_2: 'Выберите понравившуюся вам прическу ниже и добавьте свое фото.',
  Result: 'Результат',
  Original: 'Оригинал',
  unsub_tip: 'Чтобы отписаться, отправьте OFF AID на короткий номер 88800',
  sub_tip: 'Для подписки, отправьте "AID" на короткий номер 88800',
  longHairEffects: 'Эффект длинных волос',
  longHairEffects_tip: 'Попробуйте эффект длинных волос! Он придаст вам естественный и привлекательный вид. С помощью этого эффекта вы сможете увидеть, как бы вы выглядели с длинными волосами.\n' +
    'Гладкие и сияющие\n' +
    'Длинные и натуральные\n' +
    'Идеально подходит к любому наряду. С эффектом длинных волос вы будете выглядеть наилучшим образом каждый день!',
  VIDEO: 'ВИДЕО',
  style: 'Стиль',
  pic_size_limit :"Размер изображений не должен превышать 5 МБ",
  login_tip:"Нажатием кнопки «Получить SMS-код», вы осуществляете подписку на доступ к услуге на сайте <a href='https://mobiuz.snapai.asia' style='text-decoration: underline;color: white'>https://mobiuz.snapai.asia</a>, подтверждаете, что Вам уже есть 18 лет, ознакомились и согласны с условиями <a href='/#/termsAndCondition' style='text-decoration: underline;color: white'>Пользовательское соглашение</a> ее предоставления. Стоимость подписки: 1500 сум в сутки (с НДС).",

  Trending:'В тренде',
  Face_Magic:'Магия Лица',
  AI_Studio:'AI Студия',
  Home:'Главная',
  unsubscribe:'Отписаться',
  Back:'Назад',
  Chances:'Шансы',
  Setting:'Настройки',
  Menu:'Меню',
  New:'Новинка',
  image_max_size:"Размер файла превышает 5MB",
  file_max_size:"Размер файла превышает 1MB",
  new_chat:"Новый Чат",
  file:"Файл",
  image:"Изображение",
  invalid_image_format:"неверный формат файла",
  Shoot_same_video:"Создать видео",
  aiVividScene:"Яркая AI Сцена",
  aiVividScene_desc:"Запечатлите идеальное фото для любого настроения или сезона! Просто загрузите четкое фото своего лица и мгновенно изучайте различные фоны, стили и цветовые тона. Перенесите себя на летний пляж, яркий городской пейзаж, дождливую улицу или в любой фантастический мир — без необходимости путешествовать!",
  image_video:'Изображение в Видео',
  image_video_tip:'Эта функция преобразует фото в 1-3 минутное анимированное видео, добавляя естественные выражения лица и движения, чтобы оживить изображение. Пользователи также могут вернуться к ранее сгенерированным видео на вкладке История.',
  image_video_input:"Опишите стиль и внешний вид фото, которое вы хотите создать.",
  word_video:'Текст в Видео',
  word_video_tip:'Эта функция преобразует ваш написанный текст в динамическое, живое видео с использованием технологий AI, отражая ваш желаемый стиль и выражение. Генерация видео может занять 1-3 минуты, и вы можете просмотреть ранее созданные видео на вкладке История.',
  word_video_input:"Опишите стиль и внешний вид видео, которое вы хотите создать.",
  get_sms_code:"Получить SMS-код",

}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js